import { TScheduleExceptionType } from "./types";

export const weekDays = ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"];

export const exceptionTypes: {[key: TScheduleExceptionType['name']] : TScheduleExceptionType;} = {
    "Отгул": {
        name: "Отгул", 
        min_duration: 60,
        max_duration: 12 * 60,
        step: 1,
        daily_boundaries: false,
    }, 
    "Отпуск": {
        name: "Отпуск", 
        min_duration: 3 * 24 * 60,
        max_duration: 30 * 24 * 60,
        step: 24 * 60,
        daily_boundaries: true,
    },
    "Переработка": {
        name: "Переработка", 
        min_duration: 1,
        max_duration: 12 * 60,
        step: 1,
        daily_boundaries: false,
    },
    "Выходной": {
        name: "Выходной",
        min_duration: 24 * 60,
        max_duration: 3 * 24 * 60,
        step: 24 * 60,
        daily_boundaries: true,
    }
};